export default __webpack_public_path__ + "img/homepage.hero.asset.ab54ac76.jpg";